import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Icon, Typo } from 'tmt-ui-kit';

const TitleVerify = styled(Typo.HeaderFour)`
  margin: 0px 0px 8px;

  @media only screen and (max-width: 600px) {
    margin: 0px 0px 8px;
  }
`;

const VerifyStatusContainer = styled.div`
  display: flex;
`;

const IconVerify = styled(Icon)`
  margin-right: 18px;
  color: ${props => props.theme.blue};
`;

const TextVerify = styled(Typo.Paragraph)`
  line-height: 0 !important;
`;

const VerificationCheck = ({ lxprofile }) => {
  return (
    <Fragment>
      <TitleVerify>
        Verified
      </TitleVerify>
      {lxprofile.verification && lxprofile.verification.mobile_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>Phone number</TextVerify>
        </VerifyStatusContainer>
      )}
      {lxprofile.verification && lxprofile.verification.id_card_verified && lxprofile.verification.id_card_selfie_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>ID card</TextVerify>
        </VerifyStatusContainer>
      )}
      {lxprofile.verification && lxprofile.verification.email_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>Email</TextVerify>
        </VerifyStatusContainer>
      )}
      {lxprofile.verification && lxprofile.verification.facebook_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>Social media</TextVerify>
        </VerifyStatusContainer>
      )}
      {lxprofile.verification && lxprofile.verification.guide_license_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>Guide License</TextVerify>
        </VerifyStatusContainer>
      )}
      {lxprofile.verification && lxprofile.verification.criminal_record_verified && (
        <VerifyStatusContainer>
          <IconVerify name="check" />
          <TextVerify>Criminal record</TextVerify>
        </VerifyStatusContainer>
      )}
    </Fragment>
  );
};

export default VerificationCheck;
